RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const PostsWithPostTagModal = RivalIQ.apps.SocialPosts.views.PostsModal.extend({
        onBeforeRenderLoaded: function () {
            const me = this;

            const Widget = Marionette.Dashboard.widgets.get(RivalIQ.enums.widgetTypes.INSIGHTS_MEDIA);

            const postMetrics = App.utils.getDefaultPostColumnsForPostsModal(me.dashboardModel);

            const widget = new Widget(me.dashboardModel, {
                props: _.extend({}, me.dashboardModel.attributes, {
                    post_metrics: postMetrics,
                    dimensions: ['timeAnalysisMode', me.getProp('objectType'), 'channel', 'companyId'],
                    layout: 'list',
                    columnLimit: null,
                    orderBy: 4,
                    sortTable: false,
                    trailingBar: false,
                    // fake value to make widget render in details mode
                    widgetId: true,
                    // No post details modal
                    noClickThrough: !me.dashboardModel.getProp('showPostTagActionsInModal'),
                    analysisProperty: undefined,
                    modalWidget: true
                })
            });

            me.posts.showWidget(widget, null, {
                forceLoadingView: true
            });
        },

        // TODO: bump this up to SocialPosts.PostsModal level
        render: function () {
            const me = this;

            let startedBuffering = false;
            if (!RivalIQ.data.CacheLayer.isBuffering()) {
                startedBuffering = true;
                RivalIQ.data.CacheLayer.startBuffering();
            }

            RivalIQ.views.LayoutView.prototype.render.call(me);

            if (startedBuffering) {
                RivalIQ.data.CacheLayer.stopBuffering();
                RivalIQ.data.CacheLayer.flush();
            }

            return me;
        },

        loadData: function () {
            const me = this;

            // NOTE we are just returning totals here, so we don't want to even
            // think about ordering (which can cause errors when misconfigured,
            // see #22607)
            const props = _.omit(me.getProps(), ['orderBy']);

            const metricAttrs = {
                dimensions: ['timeAnalysisMode', 'channel', 'companyId', props.analysisProperty],
                property: 'count',
                channel: props.channel
            };

            const definition = App.utils.createInsightsMetric(props.objectType, metricAttrs);

            const metric = new RivalIQ.models.MetricDefinition(RivalIQ.metric.build(props, definition, {
                clobberDimensions: true
            }));

            return metric.fetch()
                .then(function (result) {
                    const mustHavePostTagIds = me.getProp('mustHavePostTagIds');
                    const metricResults = result.getValue({
                        format: false
                    });

                    const metricResult = _.find(metricResults, metricResult => {
                        if (mustHavePostTagIds && mustHavePostTagIds === metricResult[0]) {
                            return metricResult;
                        } else if (!mustHavePostTagIds && metricResult[0] === '__SUMMARY_ROW__') {
                            return metricResult;
                        }
                    });

                    me.totalNumPosts = _.last(metricResult);
                    me.numPostsShownMetric = Math.min(props.limit, me.totalNumPosts);
                });
        },

        serializeData: function () {
            const me = this;

            const channel = RivalIQ.data.channels.get(RivalIQ.enums.sourceDetails[me.getProp('source')].channel);
            const timePeriod = _.clone(me.getProp('timePeriod'));

            return {
                modalTitle: false,
                channel: channel.get('name'),
                forName: me.getProp('forName'),
                timePeriod: RivalIQ.utils.timePeriod.rehydrate(timePeriod),
                numPostsShownMetric: me.numPostsShownMetric,
                totalNumPosts: me.totalNumPosts,
                postsForDimension: me.getProp('postsForDimension') || '',
                postWord: channel.get('postName')
            };
        }
    });

    PostsWithPostTagModal.show = function (curation, props) {
        // NOTE we want to use a consistent limit (other post modals, like the
        // one in Social Posts, request 100 posts)
        props.limit = 100;

        const dashboardModel = new RivalIQ.apps.Dashboard.models.Curation(null, props);

        // post tags need the router and id setup for nav to post tags manager.
        if (props.showPostTagActionsInModal) {
            dashboardModel.id = RivalIQ.curation.id;
            dashboardModel.router = RivalIQ.curation.router;
        }

        // NOTE see #20498
        dashboardModel.presence = curation.getCuration().presence;
        RivalIQ.execute('show:modal', new PostsWithPostTagModal({
            dashboardModel: dashboardModel
        }));

        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedInsightsPostsModal);
    };

    const TableView = App.BaseDimensionTableView.mixin({

        mixins: {
            postTagsReload: RivalIQ.apps.SocialPosts.mixins.PostTagsReload
        },

        reloadOnAnyPostTagChange: true,

        getFetchAttributes: function () {
            const me = this;

            const metrics = me.metricsCollection;

            let orderByIdx = Number(me.getProp('orderBy'));
            if (!_.isFinite(orderByIdx)) {
                orderByIdx = metrics.indexOf(metrics.findWhere({
                    property: me.getProp('orderBy')
                }));
            }

            me.sortColumns = me.metricsCollection.getColumnSortOrder(orderByIdx);

            return {
                postTagsLimit: Number(me.getProp('limit') || 0),
                postTagsSortOrder: Number(me.getProp('sortOrder') || 1),
                postTagsOrderBy: metrics.at(me.sortColumns[0]).get('property'),
                limit: undefined,
                sortOrder: undefined,
                orderBy: undefined
            };
        },

        emptyViewOptions: function () {
            const me = this;
            const channel = me.getProp('channel');
            return {
                channel: channel
            };
        },

        getEmptyView: function () {
            const me = this;

            // change render template to promo when post tag is empty
            // https://github.com/RivalIQ/rivaliq-server/issues/25191
            if (_.isEmpty(me.postTagsById)) {
                // render different template if detail view.
                if (_.isUndefined(me.getProp('instanceId'))) {
                    return Marionette.ItemView.extend({
                        template: '#metricTableNoTagsHalfWidthTemplate'
                    });
                } else {
                    return Marionette.ItemView.extend({
                        template: '#metricTableNoTagsFullWidthTemplate'
                    });
                }
            }

            return Marionette.ItemView.extend({
                template: '#insightsPostTagsWidgetNoResultsTemplate',
                serializeData: function () {
                    const me = this;

                    const postName = RivalIQ.data.channels.get(me.getOption('channel')).get('postName');
                    return {
                        postName: `${postName}s`
                    };
                }
            });
        },

        _loadData: function () {
            const me = this;

            const baseLoad = RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.loadData.apply(me, arguments);

            return $.when(
                RivalIQ.postTags.data.PostTags.fetch(),
                baseLoad
            ).then(function (postTags, data) {
                me.postTagsById = _.keyBy(postTags, 'id');
                // NOTE: we need access to postTagsById to format the post tag name column
                me.dashboardModel.getCuration().postTagsById = me.postTagsById;
                me.collection = data.collection;
            });
        },

        onRowClick: function (data, e) {
            const me = this;

            e.preventDefault();

            let targetPostTagId = data[0][0];
            let targetPostTagName = _.get(me.postTagsById, [targetPostTagId, 'tag_name']);

            if (targetPostTagId === '__SUMMARY_ROW__') {
                targetPostTagId = undefined;
                targetPostTagName = undefined;
            }

            PostsWithPostTagModal.show(me.dashboardModel.curation, _.extend(me.getProps(), {
                mustHavePostTagIds: targetPostTagId,
                forName: targetPostTagName,
                postsForDimension: 'post_tag_id'
            }));
        }
    });

    function getBaseMetric(props) {
        const me = this;

        props = props || me.getProps();
        return App.utils.createInsightsMetric(props.objectType, _.defaults({
            dimensions: ['timeAnalysisMode', 'channel', 'companyId']
        }, props));
    }

    const PostTagsTable = RivalIQ.apps.Dashboard.widgets.TableWidget.mixin({
        view: TableView,
        tableClassName: 'table-fix',

        processProps: function (props) {
            const me = this;

            props = _.defaults(props, {
                sortable: true,
                orderBy: 1,
                sortOrder: 1,
                aggregateOnPostTags: true
            });

            me.baseMetric = getBaseMetric(props);

            App.utils.buildInsightsTableMetrics(me, {
                property: 'name',
                dimensions: ['post_tag_id'],
                name: 'Post Tags',
                sortable: true,
                cellView: _.constant(App.DimensionCell),
                valueFormat: function (postTagId) {
                    const postTagsById = _.get(me.getCuration(), 'postTagsById') || {};

                    if (postTagId === '__SUMMARY_ROW__') {
                        const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
                        return Marionette.TemplateCache.get('#allPostsRowCellTemplate')({
                            postWord
                        });
                    }

                    return RivalIQ.postTags.utils.makePostTagName(postTagsById, postTagId);
                },
                sort: function () {
                    return function (postTagIdA, postTagIdB, sortOrder) {
                        const tagA = _.get(me, ['postTagsById', postTagIdA, 'tag_name'], postTagIdA);
                        const tagB = _.get(me, ['postTagsById', postTagIdB, 'tag_name'], postTagIdB);
                        return RivalIQ.utils.sort.default(tagA, tagB, sortOrder);
                    };
                }
            }, props);

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_POST_TAGS_TABLE, PostTagsTable);

    const PostTagsUsageView = App.views.PostTagsUsageView = RivalIQ.views.LayoutView.mixin({
        template: '#insightsPostTagsWidgetViewTemplate',

        regions: {
            table: '.x-table'
        },

        reloadOnAnyPostTagChange: true,

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights,
            postTagsReload: RivalIQ.apps.SocialPosts.mixins.PostTagsReload
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        emptyView: Marionette.ItemView.extend({
            template: '#insightsPostTagsNoResultsTemplate'
        }),

        onRenderLoaded: _.noop,

        onBeforeRenderLoaded: function () {
            const me = this;
            me.showTable();
        },

        showTable: function () {
            const me = this;

            const widget = me.dashboardModel.getWidget('post-tags-table');
            me.table.showWidget(widget, {
                className: `table-double-header ${me.dashboardModel.isExporting() ? 'x-table-container' : 'table-responsive'}`
            });
        },

        serializeData: function () {
            return {};
        }
    });

    const PostTagsUsage = RivalIQ.apps.Dashboard.models.Widget.mixin({
        view: PostTagsUsageView,
        title: RivalIQ.strings.insights_post_tags_widget_title,
        panelView: App.views.ManageColumnsPanel,
        detailPanelView: App.views.ManageColumnsPanel,
        getExportTitle: App.utils.insightsExportTitle,
        getExportSubtitle: App.utils.insightsExportSubtitle,
        getPptSubtitle: App.utils.insightsPptSubtitle,
        scheduledExportAdvancedSettingsEnabled: false,

        description: function () {
            const me = this;

            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            return RivalIQ.str('insights_post_tags_description', postWord);
        },

        exportFormats: [
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.CSV
        ],

        viewMorePath: function () {
            const me = this;

            return me.getPath({
                limit: -1,
                orderBy: me.getProp('orderBy'),
                sortOrder: me.getProp('sortOrder')
            });
        },

        filter: function () {
            const me = this;
            let filter = false;

            if (RivalIQ.apps.Insights.utils.isLoadingInstagramPromotedPosts(me)) {
                filter = true;
            }

            return filter;
        },

        getPropsForSerialization: function (props) {
            return _.pick(props, 'post_metrics');
        },

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                limit: 8,
                analysisProperty: 'post_tag_ids',
                omitTimeAnalysisModeDescription: true,
                showPostTagActionsInModal: true
            });

            // NOTE if we are in a summary view we want to limit the metrics
            // to three (plus the dimension name column for four total) and
            // not show the All Posts summary.
            if (!me.isFocus()) {
                props.columnLimit = 4;
                props.includeSummaryRow = false;
            } else {
                delete props.columnLimit;
            }

            if (props.objectType === RivalIQ.enums.insightsObjectType.post && props.source === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS && _.isEmpty(props.post_metrics)) {
                const hasPaidEngagement = App.utils.hasInstagramPaidEngagement(me);
                if (hasPaidEngagement) {
                    props.post_metrics = [
                        'count',
                        'impressions',
                        'engagement_rate_by_impression'
                    ];
                } else {
                    props.post_metrics = [
                        'count',
                        'organic_impressions',
                        'organic_engagement_rate_by_impression'
                    ];
                }

                if (_.isEmpty(me.configurationProps.post_metrics)) {
                    me.configurationProps.post_metrics = props.post_metrics;
                }
            }

            me.baseMetric = App.utils.createInsightsMetric(props.objectType, _.defaults({
                dimensions: ['timeAnalysisMode', 'channel', 'companyId']
            }, props));

            return props;
        },

        csvExportProps: function () {
            const me = this;
            const props = me.getProps();

            return {
                type: 'postTags',
                isPrivateData: true,
                analysisProperty: props.analysisProperty,
                metric: _.defaults({
                    landscapeId: props.landscapeId
                }, me.widgets.at(0).metrics[0].serialize()) // the post tag table metric
            };
        },

        widgetDefinitions: function () {
            const me = this;

            const props = {
                showDescriptions: true,
                trailingBar: true,
                showProgressBar: false
            };

            const widgets = [{
                instanceId: 'post-tags-table',
                neverFilter: true,
                widgetId: RivalIQ.enums.widgetTypes.INSIGHTS_POST_TAGS_TABLE,
                baseMetric: me.baseMetric,
                props: props
            }];

            return widgets;
        },

        allowPageBreaks: App.utils.allowPageBreaksInFocus
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSIGHTS_POST_TAGS, PostTagsUsage);
});
